// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import type { Card } from 'app/scripts/models/Card';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { StickerView } from 'app/scripts/views/stickers/StickerView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// @ts-expect-error
interface StickerEditView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editTraceId: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
}

class StickerEditView extends StickerView {
  static initClass() {
    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ mouseenter: string; mouseleave: string; mo... Remove this comment to see the full error message
      mouseenter: 'mouseenter',
      mouseleave: 'mouseleave',
      mousedown: 'editSticker',
      'mousedown .js-remove-sticker': 'removeSticker',
    };

    // @ts-expect-error TS(2339): Property 'editTraceId' does not exist on type 'typ... Remove this comment to see the full error message
    this.editTraceId = null;
  }

  initialize() {
    this.listenTo(this.model, 'stopEditing', this.stopEditing);
    this.listenTo(this.model, 'startEditing', this.editSticker);
    this.listenTo(this.model, 'disableEditing', this.disableEditing);
    return this.listenTo(this.model, 'enableEditing', this.enableEditing);
  }

  showEditControls() {
    return true;
  }

  disableEditing() {
    return this.$el.addClass('editing-disabled');
  }

  enableEditing() {
    return this.$el.removeClass('editing-disabled');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stopEditing(e: any) {
    stopPropagationAndPreventDefault(e);

    if (this.isEditing()) {
      this.$el.removeClass('editing');
      $('.quick-card-editor').removeClass('quick-card-editor-editing-stickers');
      return Array.from(this.model.collection.models).map((sticker) =>
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        sticker.trigger('enableEditing'),
      );
    }
  }

  isEditing() {
    return this.$el.is('.editing');
  }

  isEditingDisabled() {
    return this.$el.is('.editing-disabled');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseenter(e: any) {
    if (!this.isEditingDisabled()) {
      this.$el.addClass('hover');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseleave(e: any) {
    this.$el.removeClass('hover');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editSticker(e: any) {
    if (e !== null && e.which !== 1) {
      // Non-left-click
      return;
    }

    stopPropagationAndPreventDefault(e);

    // NOTE: We clone the array, so it doesn't get changed out from under us
    // when the models save
    const stickers = _.clone(this.model.collection.models);
    for (const otherSticker of Array.from(stickers)) {
      if (otherSticker !== this.model) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        otherSticker.trigger('stopEditing');
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        otherSticker.trigger('disableEditing');
      }
    }

    // Defer adding the class so the controls-popping-out animation works on the
    // first click (we have to have it be in the DOM in non-editing mode so we
    // can css-transition to editing mode)
    this.defer(() => {
      PopOver.hide();
      this.$el.addClass('editing');
      return $('.quick-card-editor').addClass(
        'quick-card-editor-editing-stickers',
      );
    });
  }

  // @ts-expect-error TS(2425): Class 'StickerView' defines instance member proper... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSticker(e: any) {
    if (this.isEditing()) {
      const remove = _.once(() => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.stopEditing();
        this.model.destroyWithTracing(
          {
            traceId: this.editTraceId,
          },
          tracingCallback(
            {
              taskName: 'edit-card/stickers',
              traceId: this.editTraceId,
              source: 'stickerEditView',
              attributes: {
                action: 'removed',
              },
            },
            (_err, sticker) => {
              if (sticker) {
                const card = this.options?.card as Card | undefined;
                Analytics.sendUpdatedCardFieldEvent({
                  field: 'stickers',
                  source: 'stickerEditView',
                  attributes: {
                    taskId: this.editTraceId,
                    action: 'removed',
                  },
                  containers: {
                    card: {
                      id: card?.id,
                    },
                    board: {
                      id: card?.get('idBoard'),
                    },
                    list: {
                      id: card?.get('idList'),
                    },
                  },
                });
              }
            },
          ),
        );
        this.$el.remove();
      });

      this.$el.one('transitionEnd webkitTransitionEnd', remove);

      this.setTimeout(remove, 100);

      this.$el.addClass('fade-out');
    }
  }
}

StickerEditView.initClass();
export { StickerEditView };
